/** Brand corner — the "V" mark + Backoffice wordmark (mirrors the mockup). */
export function Brand() {
    return (
        <div className="flex items-center gap-2.5">
            <div className="flex size-[30px] items-center justify-center rounded-lg bg-gradient-to-br from-brand to-brand-700 text-base font-bold text-white">
                V
            </div>
            <div className="text-[15px] font-semibold leading-tight tracking-tight text-content">
                Backoffice
                <span className="block text-[11px] font-medium text-content-muted">
                    Veevart Internal
                </span>
            </div>
        </div>
    );
}
